module.exports = __webpack_public_path__ + "static/media/YM08_0.cd875ac6.jpg";